import { render, staticRenderFns } from "./packageCourse.vue?vue&type=template&id=14b7a5ba&scoped=true&"
import script from "./packageCourse.vue?vue&type=script&lang=js&"
export * from "./packageCourse.vue?vue&type=script&lang=js&"
import style0 from "./packageCourse.vue?vue&type=style&index=0&id=14b7a5ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b7a5ba",
  null
  
)

export default component.exports